import React from "react";

import NestedMenu from "components/Shared/NestedMenu";

const ReferralSidebar = () => {
  const referrerMenuOptions = [
    {
      title: "Dashboard",
      path: "/app/referral/dashboard",
      icon: "DashboardCustomize",
    },
    {
      title: "Leads",
      path: "/app/referral/lead/list",
      icon: "BookmarkAddOutlined",
    },
  ];

  return <NestedMenu menu={referrerMenuOptions} />;
};

export default ReferralSidebar;
